<template>
  <div class="share">

    <van-popup v-model="shareMenuShow" round position="bottom" :style="{ height: '146px' }">
      <div class="share-main">
        <div class="share-item copy-link" ref="copyButton" :data-clipboard-text="'《' + title + '》 - ' + type + ' - 凯诺设计课' + '\n' + src">
          <div class="share-icon copy"><icon icon-class="link"></icon></div>
          <span>复制链接</span>
        </div>
        <div class="share-item qq" @click="shareToQQ">
          <div class="share-icon qq"><icon icon-class="icon3"></icon></div>
          <span>QQ好友</span>
        </div>
        <div class="share-item sina" @click="shareToWeibo">
          <div class="share-icon sina"><icon icon-class="unie61d"></icon></div>
          <span>新浪微博</span>
        </div>
      </div>
      <button class="cancel" @click="hideMenu">取消</button>
    </van-popup>
    <van-popup v-model="copySuccess" class="copy-success-popup"><icon icon-class="copy-success"></icon><p>复制链接成功</p></van-popup>
  </div>
</template>

<style lang="less" scoped>
  .share{
    .share-main{
      width: 100%;
      height: 98px;
      padding: 0 30px;
      display: flex;
      justify-content: space-between;
      .share-item{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        .share-icon{
          width: 44px;
          height: 44px;
          background: #000;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 50%;
          &.copy{
            background: @cano;
          }
          &.qq{
            background: #54B5EF;
          }
          &.sina{
            background: #D32024;
          }
          svg{
            color: #FFF;
            font-size: 20px;
          }
        }
        span{
          font-size: 12px;
          line-height: 12px;
          margin-top: 8px;
          color: #333;
        }
      }
    }
    .cancel{
      width: 100%;
      height: 48px;
      border: 0;
      background: #F7F7F7;
      font-size: 14px;
      color: #333;
    }
    .copy-success-popup{
      padding: 26px 0;
      width: 270px;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      svg{
        font-size: 32px;
        color: #53B488;
      }
      p{
        font-size: 16px;
        line-height: 16px;
        margin-top: 16px;
        color: #333;
      }
    }
  }
</style>

<script>
  export default {
    props: {
      extraClass: String,
      src: String,
      title: String,
      type: String,
      list: Boolean,
    },
    data() {
      return {
        shareMenuShow: false,
        copySuccess: false,
        clipboard: null,
      }
    },
    created() {},
    mounted() {

      // 获取基本信息后初始化百度分享设置
      // window._bd_share_config = {
      //   common: {
      //     bdText: `《${this.title}》 - 凯诺设计课 Canopy Institute of Design`, //分享的内容
      //     bdUrl: this.src, //分享的url
      //     bdSign: 'off' //禁用回流
      //   },
      //   share : [{
      //     bdCustomStyle: ' '
      //   }]
      // }
      // if(document.getElementById('bdShareScriptTag')) return;
      // let shareScript = document.createElement('script');
      // shareScript.id = 'bdShareScriptTag';
      // shareScript.src = '/Application/Home/Resource/vendor/bdShare/static/api/js/share.js?cdnversion='+~(-new Date()/36e5);
      // document.getElementsByTagName('body')[0].appendChild(shareScript);
    },
    methods: {
      showMenu() {
        this.shareMenuShow = true;
        this.$nextTick(() => {
          if(!this.clipboard) {
            let copyButton = this.$refs.copyButton;
            this.clipboard = new this.ClipboardJS(copyButton);
            this.clipboard.on('success', (e) => {
              this.copySuccess = true;
              setTimeout(() => {
                this.copySuccess = false;
              }, 1000);
            })
          }
        })
      },
      hideMenu(e) {
        this.shareMenuShow = false;
      },
      shareToQQ() {
        let titleText = `《${this.title}》 - 凯诺设计课 Canopy Institute of Design`
        const shareUrl = `https://connect.qq.com/widget/shareqq/index.html?url=${encodeURIComponent(this.src)}&desc=${titleText}&summary=&site=baidu`;
        window.open(shareUrl);
      },
      shareToWeibo() {
        let titleText = `《${this.title}》 - 凯诺设计课 Canopy Institute of Design`
        const shareUrl = `https://service.weibo.com/share/share.php?url=${encodeURIComponent(this.src)}&title=${titleText}&appkey=1343713053&searchPic=true&sudaref=s.share.baidu.com&display=0&retcode=6102#_loginLayer_1603098519698`;
        window.open(shareUrl);
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/share.vue